import { render, staticRenderFns } from "./MarketReceive.vue?vue&type=template&id=b9ddb4e2&scoped=true&"
import script from "./MarketReceive.vue?vue&type=script&lang=js&"
export * from "./MarketReceive.vue?vue&type=script&lang=js&"
import style0 from "./MarketReceive.vue?vue&type=style&index=0&id=b9ddb4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ddb4e2",
  null
  
)

export default component.exports